// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "Explore our Tech Review Module for expert insights and evaluations on the latest gadgets, software, and emerging technologies, keeping you informed and empowered in the dynamic world of tech.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Tech Review",
  id: "tech-review",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable", "Explainer"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/tech-review/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(// Set webpackChunkName to dynamic import PhotoGalleryConfigTool in order to get all the css styles for the image crop.
      /* webpackChunkName: "PhotoGalleryConfigTool" */ "app/components/tools/TechReviewConfigTool/TechReviewConfigTool"),
    loading: DynamicImportLoader,
    modules: ["TechReviewConfigTool"]
  })
};

export default CONFIG;
